
import { Component, Vue } from "vue-property-decorator";
import {
  eImzaIndirmeleriGetir,
  EImzaServisIndirme,
  EIMZA_SERVIS_INDIR_ETIKET,
} from "@/enum/EImzaServisIndirmeleri";

@Component
export default class EImzaServisIndir extends Vue {
  readonly etiket: string = EIMZA_SERVIS_INDIR_ETIKET;

  // Kullanıcının işletim sistemine göre süzülür: Windows'ta yalnız Windows,
  // Mac'te iki Mac paketi, diğer sistemlerde hepsi.
  get indirmeler(): EImzaServisIndirme[] {
    return eImzaIndirmeleriGetir();
  }
}
